import {Injectable} from "@angular/core";
import {map, Observable} from "rxjs";
import {ApiClient} from "../../tools/api-client";
import {recursiveNullToUndefined} from "../../tools/recursive-null-to-undefined";

@Injectable()
export class ReleaseFeaturesService {

  constructor(private readonly apiClient: ApiClient) {
  }

  getFeatures(): Observable<Feature[]> {
    return this.apiClient.get<Feature[]>("/api/release-toggles")
      .pipe(map(recursiveNullToUndefined));
  }

  releaseFeature(name: string): Observable<void> {
    return this.apiClient.put<void>(`/api/release-toggles/${name}/release`);
  }
}

export interface Feature {
  name: string;
  released: boolean;
}
